import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function AdminIDCards() {

  const token = localStorage.getItem("access");
  const { t } = useTranslation();

  const [classes, setClasses] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");

  const [students, setStudents] = useState([]);

  const [selectedStudent, setSelectedStudent] = useState(null);

  // =====================================================
  // LOAD CLASSES
  // =====================================================

  useEffect(() => {

    fetchClasses();

  }, []);

  useEffect(() => {

  const style = document.createElement("style");

  style.innerHTML = `
@media print {

  body * {
    visibility: hidden;
  }

  .print-card,
  .print-card * {
    visibility: visible;
  }

  .print-card {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

}
  `;

  document.head.appendChild(style);

  return () => {
    document.head.removeChild(style);
  };

}, []);

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // LOAD STUDENTS
  // =====================================================

  const fetchStudents = async (classId) => {

  try {

    const res = await axios.get(
      `https://api.eduskot.com/api/academics/class-students/${classId}/`,
      {
        headers:{
          Authorization:`Bearer ${token}`
        }
      }
    );

    console.log(res.data);

    setStudents(res.data.students);

  } catch (err) {

    console.error(err);
  }
};

  // =====================================================
  // CLASS CHANGE
  // =====================================================

  const handleClassChange = (e) => {

    const value = e.target.value;

    setSelectedClass(value);

    setSelectedStudent(null);

    if (value) {
      fetchStudents(value);
    }
  };

  // =====================================================
  // CALCULATE AGE
  // =====================================================

  const calculateAge = (date) => {

    if (!date) return "--";

    const birth = new Date(date);

    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();

    return age;
  };


  const getIssueDate = () => {

  const today = new Date();

  return today.toLocaleDateString("en-GB");
};

const getExpiryDate = () => {

  const expiry = new Date();

  expiry.setFullYear(
    expiry.getFullYear() + 1
  );

  return expiry.toLocaleDateString("en-GB");
};

  // =====================================================
  // PRINT
  // =====================================================

  const printCard = () => {

    window.print();
  };

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <h1>{t("schoolIdCardGenerator")}</h1>

        <div style={{ display:"flex", gap:"10px" }}>

          <button
            style={styles.printBtn}
            onClick={printCard}
          >
            {t("printIdCard")}
          </button>

          <button
            style={styles.backBtn}
            onClick={() =>
              window.location.href =
              "/admin-dashboard"
            }
          >
            {t("back")}
          </button>

        </div>

      </div>

      {/* SELECT CLASS */}

      <div style={styles.topCard}>

        <select
          value={selectedClass}
          onChange={handleClassChange}
          style={styles.select}
        >

          <option value="">
            Select Class
          </option>

          {classes.map((c)=>(
            <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>
          ))}

        </select>

      </div>

      {/* STUDENTS */}

      {students.length > 0 && (

        <div style={styles.studentGrid}>

          {students.map((student)=>(

            <div
              key={student.id}
              style={styles.studentCard}
              onClick={() =>
                setSelectedStudent(student)
              }
            >

              <img
                src={
                  student.profile_picture ||
                  "https://via.placeholder.com/100"
                }
                alt="student"
                style={styles.studentImage}
              />

              <h3>
                {student.full_name}
              </h3>

              <p>
                {student.admission_number}
              </p>

            </div>
          ))}

        </div>
      )}

      {/* ID CARD */}

{selectedStudent && (

  <div
  className="print-card"
  style={styles.idContainer}
>

    <div
  style={{
    ...styles.idCard,
    position:"relative"
  }}
>
<img
  src={selectedStudent.school_logo}
  alt=""
  style={{
    position:"absolute",
    top:"50%",
    left:"50%",
    transform:"translate(-50%, -50%)",
    width:"380px",
    opacity:"0.05",
    pointerEvents:"none",
    zIndex:0
  }}
/>
<div
  style={{
    position:"absolute",
    top:"50%",
    left:"50%",
    transform:"translate(-50%, -50%) rotate(-25deg)",
    fontSize:"60px",
    fontWeight:"900",
    color:"#0b4ea2",
    opacity:"0.04",
    whiteSpace:"nowrap",
    pointerEvents:"none",
    zIndex:0
  }}
>
  {selectedStudent.school_name}
</div>
      {/* HEADER */}

<div
  style={{
    background:"#0779fb",
    position:"relative",
    zIndex:2,
    color:"white",
    padding:"10px 20px",
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between"
  }}
>

  {/* LEFT SIDE */}

  <img
    src={
      selectedStudent.school_logo ||
      "https://via.placeholder.com/70"
    }
    alt="School Logo"
    style={{
      width:"50px",
      height:"50px",
      objectFit:"cover",
      borderRadius:"50%",
      objectFit:"contain"
    }}
  />

  {/* CENTER */}

  <div
    style={{
      textAlign:"center",
      flex:1
    }}
  >

    <h2
      style={{
        margin:0,
        fontSize:"34px"
      }}
    >
      {selectedStudent.school_name}
    </h2>

    <p
      style={{
        margin:0,
        fontSize:"18px"
      }}
    >
      STUDENT IDENTITY CARD(Carte Élève)
    </p>

  </div>

  {/* RIGHT SIDE */}

  <img
    src="https://flagcdn.com/w80/cm.png"
    alt="Cameroon Flag"
    style={{
      width:"55px",
      height:"40px",
      objectFit:"cover",
      borderRadius:"4px",
      border:"2px solid white"
    }}
  />

</div>

      {/* BODY */}

      <div
        style={{
          display:"flex",
          position:"relative",
          zIndex:2,
          padding:"30px",
          gap:"40px",
          alignItems:"flex-start",
        }}
      >

        {/* PHOTO */}

        <div
          style={{
            width:"220px",
            textAlign:"center",
            flexShrink:0,
            positon:"relative",
          }}
        >

          <img
  src={
    selectedStudent.profile_picture ||
    "https://via.placeholder.com/150"
  }
  alt="student"
  style={{
    width:"200px",
    height:"240px",
    objectFit:"cover",
    border:"3px solid #0b4ea2",
    borderRadius:"8px",
    background:"#fff"
  }}
/>


        </div>

        {/* DETAILS */}

<div
  style={{
    flex:1
  }}
>

  <h2
    style={{
      color:"#0b4ea2",
      marginTop:0,
      marginBottom:"25px"
    }}
  >
    {selectedStudent.full_name}
  </h2>

  <div
    style={{
      display:"grid",
      gridTemplateColumns:"1fr 1fr",
      gap:"13px 40px",
      fontSize:"17px"
    }}
  >

    <div>
      <strong>Reg. Number(Matricule):</strong>{" "}
      
      {selectedStudent.admission_number}
    </div>

    <div>
      <strong>Date of Birth(Naissance):</strong>{" "}
      
      {selectedStudent.date_of_birth || "--"}
    </div>

    <div>
  <strong>Class(Classe):</strong>{" "}
  {selectedStudent.class}
</div>

   
     <div>
  <strong>Mother's Name (Mère):</strong>{" "}
  {selectedStudent.mother_name || "--"}
</div>
  

    <div>
      <strong>Place of Birth(Lieu):</strong>{" "}
      {selectedStudent.place_of_birth || "--"}
    </div>

    <div>
  <strong>Father's Name (Père):</strong>{" "}
  {selectedStudent.father_name || "--"}
</div>

    <div>
      <strong>Gender(Sexe):</strong>{" "}
      
      {selectedStudent.gender}
    </div>
   
    <div>
  <strong>Session:</strong>{" "}
  {selectedStudent.session || "--"}
</div>

<div>
      <strong>NIU:</strong>{" "}
      
      {selectedStudent.niu || "--"}
    </div>



<div
  style={{
    marginTop:"40px",
    textAlign:"center"
  }}
>

  <div
    style={{
      width:"120px",
      borderTop:"2px solid #64748b",
      margin:"0 auto 8px"
    }}
  />

<div
  style={{
    color:"#1e3a8a",
    fontSize:"28px",
    fontFamily:"cursive",
    fontWeight:"600",
    marginBottom:"5px",
    fontStyle:"italic"
  }}
>
  {selectedStudent.principal_name}
</div>

  <div
    style={{
      fontSize:"13px",
      color:"#8b6464"
    }}
  >
    Principal(Directeur)
  </div>





</div>
    

  </div>

</div>
      </div>

      {/* FOOTER */}

  

<div
  style={{
    background:"#f59e0b",
    position:"relative",
    zIndex:2,
    color:"white",
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    padding:"10px 25px",
    fontWeight:"700"
  }}
>

  <span>
    VALID SCHOOL IDENTIFICATION
  </span>

  <span>
    Valid Until(Valide Jusqu'au): {getExpiryDate()}
  </span>

</div>
<div
  style={{
    textAlign:"center",
    padding:"18px 30px 25px",
    color:"#120a4b",
    fontSize:"18px",
    fontStyle:"italic",
    letterSpacing:"1px",
    fontWeight:"800",
    borderTop:"1px solid #e2e8f0"
  }}
>
  ❝ {selectedStudent.school_motto} ❞
</div>
    </div>

  </div>

)}

</div>
);
}

const styles = {

  page:{
    minHeight:"100vh",
    padding:"7px",
    background:"#f1f5f9",
    fontFamily:"Segoe UI"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"30px",
    flexWrap:"wrap",
    gap:"10px"
  },

  topCard:{
    background:"white",
    padding:"20px",
    borderRadius:"14px",
    marginBottom:"30px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  select:{
    width:"100%",
    padding:"14px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  studentGrid:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
    gap:"20px",
    marginBottom:"40px"
  },

  studentCard:{
    background:"white",
    padding:"20px",
    borderRadius:"14px",
    textAlign:"center",
    cursor:"pointer",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  studentImage:{
    width:"100px",
    height:"100px",
    borderRadius:"50%",
    objectFit:"cover",
    marginBottom:"15px"
  },

  idContainer:{
    display:"flex",
    justifyContent:"center"
  },

idCard:{
    width:"950px",
    maxWidth:"100%",
    minHeight:"520px",
    borderRadius:"20px",
    overflow:"hidden",
    boxShadow:"0 15px 35px rgba(0,0,0,0.15)",
    background:"white",
    position:"relative"
},

  idTop:{
    background:"#2563eb",
    color:"white",
    padding:"20px",
    textAlign:"center"
  },

  photoSection:{
    display:"flex",
    justifyContent:"center",
    marginTop:"20px"
  },

  idPhoto:{
    width:"120px",
    height:"120px",
    borderRadius:"14px",
    objectFit:"cover",
    border:"4px solid #2563eb"
  },

  details:{
    padding:"25px"
  },

  footer:{
    background:"#e2e8f0",
    textAlign:"center",
    padding:"14px",
    fontWeight:"600"
  },

  backBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"10px",
    background:"#2563eb",
    color:"white",
    cursor:"pointer"
  },

  printBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"10px",
    background:"#16a34a",
    color:"white",
    cursor:"pointer"
  }
};

export default AdminIDCards;